import axios from 'axios';
import { ICrudSearchAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction, Storage } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { SERVER_API_URL } from 'app/config/constants';

import { IOrder, IOrderToken, defaultValue } from 'app/shared/model/order.model';
import { ITransaction, defaultValue as transactionDefaultValue } from 'app/shared/model/transaction.model';
import { showTimer } from 'app/shared/util/toast-util';

export const ACTION_TYPES = {
  GET_ORDER_TOKEN: 'order/GET_ORDER_TOKEN',
  CREATE_ORDER: 'order/CREATE_ORDER',
  RESET: 'order/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IOrder>,
  entity: defaultValue,
  orderToken: null,
  updating: false,
  updateSuccess: false,
  transaction: transactionDefaultValue
};

export type OrderState = Readonly<typeof initialState>;

// Reducer

export default (state: OrderState = initialState, action): OrderState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_ORDER_TOKEN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_ORDER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.GET_ORDER_TOKEN):
    case FAILURE(ACTION_TYPES.CREATE_ORDER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.GET_ORDER_TOKEN):
      Storage.session.set('ORDER_TOKEN', action.payload.data);
      return {
        ...state,
        updateSuccess: true,
        loading: false
      };
    case SUCCESS(ACTION_TYPES.CREATE_ORDER):
      Storage.session.set('TRANSACTION', action.payload.data);
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = SERVER_API_URL + '/api/order';

// Actions

export const getOrderToken = history => {
  const requestUrl = `${apiUrl}/acquire-token`;
  return {
    type: ACTION_TYPES.GET_ORDER_TOKEN,
    payload: axios.get<IOrderToken>(requestUrl),
    history
  };
};

export const createEntity: ICrudPutAction<IOrder> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_ORDER,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
